var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoEeti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 47,
    viewBox: "0 0 111 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_70_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25713 5.74707H0.82373V36.4526H6.25713V5.74707Z",
    fill: "url(#paint0_linear_70_760)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_70_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7719 5.74707H9.06128V10.4676H26.7719V5.74707Z",
    fill: "url(#paint1_linear_70_760)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_70_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7725 18.7295H6.25696V23.4703H23.7725V18.7295Z",
    fill: "url(#paint2_linear_70_760)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_70_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8051 12.5195H31.7142V17.2401H41.8051V12.5195Z",
    fill: "url(#paint3_linear_70_760)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_70_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4786 12.5195H13.7977V17.2401H30.4786V12.5195Z",
    fill: "url(#paint4_linear_70_760)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_70_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4786 38.585H13.7977V43.3055H30.4786V38.585Z",
    fill: "url(#paint5_linear_70_760)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_70_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8051 38.3799H31.7142V43.1004H41.8051V38.3799Z",
    fill: "url(#paint6_linear_70_760)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_70_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6828 31.8125H9.06128V36.533H23.6828V31.8125Z",
    fill: "url(#paint7_linear_70_760)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_70_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1241 12.5195H30.5575V43.2251H25.1241V12.5195Z",
    fill: "url(#paint8_linear_70_760)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.8677 31.1722C61.0778 31.1722 62.6829 29.3593 62.6829 25.7335H63.3248V31.8119H48.2377V31.1722H49.8427V14.5363H48.2377V13.8965H63.0038V19.3351H62.3619C62.3619 17.4369 61.9765 16.1679 61.2061 15.5281C60.4571 14.8669 59.2374 14.5363 57.5468 14.5363H54.6578V22.2145H55.9418C57.4826 22.2145 58.4563 22.0224 58.863 21.6386C59.2695 21.2546 59.4728 20.4868 59.4728 19.3351H60.1149V25.7335H59.4728C59.4728 24.539 59.2695 23.7605 58.863 23.3981C58.4563 23.0354 57.4826 22.8542 55.9418 22.8542H54.6578V31.1722H57.8677ZM75.36 31.1722C78.5701 31.1722 80.175 29.3593 80.175 25.7335H80.8171V31.8119H65.7299V31.1722H67.3348V14.5363H65.7299V13.8965H80.496V19.3351H79.8541C79.8541 17.4369 79.4688 16.1679 78.6984 15.5281C77.9494 14.8669 76.7297 14.5363 75.0389 14.5363H72.15V22.2145H73.4341C74.9749 22.2145 75.9485 22.0224 76.3551 21.6386C76.7618 21.2546 76.965 20.4868 76.965 19.3351H77.607V25.7335H76.965C76.965 24.539 76.7618 23.7605 76.3551 23.3981C75.9485 23.0354 74.9749 22.8542 73.4341 22.8542H72.15V31.1722H75.36ZM98.9192 19.3351C98.9192 17.4369 98.5983 16.1679 97.9562 15.5281C97.3355 14.8669 96.1586 14.5363 94.4252 14.5363H93.4622V31.1722H95.7092V31.8119H86.4V31.1722H88.647V14.5363H87.6841C85.9721 14.5363 84.795 14.8669 84.1531 15.5281C83.5324 16.1679 83.222 17.4369 83.222 19.3351H82.5801V13.8965H99.5613V19.3351H98.9192ZM109.523 31.8119H101.498V31.1722H103.103V14.5363H101.498V13.8965H109.523V14.5363H107.918V31.1722H109.523V31.8119Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3871 36.4517H56.4047L56.9824 38.1901L56.2461 38.4384L55.7931 37.2306H53.3692V39.3415H55.2381V40.1204H53.3579V42.3216H54.7397V43.1005H51.3757V42.3216H52.4631L52.4744 37.2306H51.3871V36.4517ZM59.6643 38.0885C60.1701 38.0885 60.6081 38.1938 60.9782 38.4046C61.3556 38.6078 61.6501 38.9049 61.8616 39.2963C62.0729 39.6801 62.1788 40.143 62.1788 40.6848C62.1788 41.4899 61.9483 42.1221 61.4878 42.5812C61.0272 43.0403 60.4192 43.2698 59.6643 43.2698C59.1809 43.2698 58.7505 43.1682 58.3731 42.965C58.003 42.7542 57.7122 42.457 57.5009 42.0732C57.297 41.6818 57.1951 41.219 57.1951 40.6848C57.1951 40.143 57.297 39.6801 57.5009 39.2963C57.7122 38.9049 58.003 38.6078 58.3731 38.4046C58.7505 38.1938 59.1809 38.0885 59.6643 38.0885ZM59.6756 38.8109C59.1546 38.8109 58.7619 38.9766 58.4976 39.3076C58.2332 39.6313 58.1012 40.0902 58.1012 40.6848C58.1012 41.2794 58.2332 41.7383 58.4976 42.0619C58.7619 42.3856 59.1546 42.5473 59.6756 42.5473C60.2117 42.5473 60.6118 42.3856 60.8762 42.0619C61.1404 41.7383 61.2726 41.2794 61.2726 40.6848C61.2726 40.0902 61.1404 39.6313 60.8762 39.3076C60.6118 38.9766 60.2117 38.8109 59.6756 38.8109ZM67.5416 42.7731C67.3 42.9235 67.0282 43.044 66.7261 43.1343C66.4242 43.2246 66.141 43.2698 65.8766 43.2698C65.1819 43.2698 64.6685 43.1154 64.3362 42.807C64.0116 42.4985 63.8491 42.0168 63.8491 41.3621V38.9577H62.8977V38.2578H64.7326V41.1815C64.7326 41.6632 64.8271 42.0131 65.0158 42.2313C65.2122 42.4421 65.518 42.5473 65.9332 42.5473C66.175 42.5473 66.4316 42.5135 66.7034 42.4457C66.9752 42.3704 67.1944 42.2764 67.3604 42.1635V38.9577H66.4089V38.2578H68.2438V42.22L69.3085 42.5812L69.082 43.3037L67.5416 42.7731ZM70.0151 43.1005V42.4006H70.9665V39.1609L69.8792 38.7884L70.117 38.0885L71.6234 38.6078C71.8877 38.4347 72.1671 38.3067 72.4616 38.224C72.7637 38.1337 73.0582 38.0885 73.3451 38.0885C73.7075 38.0885 74.0397 38.1599 74.3418 38.303C74.6513 38.4384 74.8968 38.6492 75.078 38.9351C75.2669 39.2136 75.3612 39.5673 75.3612 39.9962V42.4006H76.3126V43.1005H73.968V42.4006H74.4777V40.1768C74.4777 39.6951 74.3531 39.3491 74.104 39.1383C73.8624 38.9201 73.5603 38.8109 73.1978 38.8109C72.9863 38.8109 72.7637 38.8448 72.5296 38.9125C72.303 38.9727 72.0765 39.0669 71.85 39.1947V42.4006H72.3597V43.1005H70.0151ZM82.376 43.2924L80.8696 42.7731C80.4089 43.1042 79.9182 43.2698 79.3972 43.2698C78.6193 43.2698 78.0116 43.0327 77.5736 42.5586C77.1432 42.0769 76.928 41.4148 76.928 40.5719C76.928 39.7893 77.1432 39.1798 77.5736 38.7432C78.0116 38.3067 78.6193 38.0885 79.3972 38.0885C79.601 38.0885 79.8125 38.1111 80.0314 38.1562C80.258 38.1938 80.4656 38.2502 80.6544 38.3256V36.8468L79.5784 36.4743L79.8162 35.7744L81.5379 36.3614V42.2087L82.6026 42.5699L82.376 43.2924ZM79.4085 42.5473C79.5973 42.5473 79.8049 42.5098 80.0314 42.4345C80.258 42.3517 80.4656 42.2502 80.6544 42.1297V39.0932C80.4882 39.0104 80.2882 38.9427 80.0541 38.89C79.8276 38.8372 79.6124 38.8109 79.4085 38.8109C78.9404 38.8109 78.559 38.9727 78.2645 39.2963C77.9776 39.6124 77.8341 40.0338 77.8341 40.5606C77.8341 41.1552 77.9776 41.6367 78.2645 42.0055C78.559 42.3667 78.9404 42.5473 79.4085 42.5473ZM86.7987 42.7731C86.308 43.1042 85.7756 43.2698 85.2017 43.2698C84.5674 43.2698 84.0841 43.1419 83.7519 42.886C83.4271 42.6301 83.2611 42.2575 83.2535 41.7685C83.2385 40.7827 83.8652 40.2897 85.1337 40.2897L86.5949 40.301C86.5949 39.7967 86.5005 39.4242 86.3117 39.1835C86.1228 38.9351 85.836 38.8109 85.4509 38.8109C85.2697 38.8109 85.0921 38.8222 84.9185 38.8448C84.7449 38.8674 84.5824 38.9012 84.4315 38.9464L84.3182 39.5673L83.5933 39.4318L83.7745 38.4046C84.0614 38.2993 84.3409 38.2203 84.6127 38.1675C84.8922 38.1148 85.1601 38.0885 85.4169 38.0885C86.0965 38.0885 86.6099 38.2728 86.9573 38.6416C87.3047 39.0028 87.4783 39.541 87.4783 40.2558V42.22L88.5543 42.5699L88.3278 43.2924L86.7987 42.7731ZM85.1677 41.0009C84.843 41.0009 84.5938 41.0649 84.4202 41.1928C84.2466 41.3206 84.1596 41.5088 84.1596 41.7572C84.1596 42.284 84.5221 42.5473 85.247 42.5473C85.768 42.5473 86.2174 42.4043 86.5949 42.1184V41.0121L85.1677 41.0009ZM91.373 43.2698C91.1012 43.2698 90.8407 43.217 90.5915 43.1118C90.3499 43.0065 90.1537 42.8183 90.0025 42.5473C89.8515 42.2764 89.776 41.9002 89.776 41.4185V38.9577H88.8359V38.2578H89.776V37.1629L90.6368 36.9597V38.2578H92.0526V38.9577H90.6368V40.9218C90.6368 41.4261 90.686 41.8325 90.784 42.141C90.8823 42.4494 91.0975 42.6038 91.4296 42.6038C91.6638 42.6038 91.928 42.5361 92.2225 42.4006L92.3924 43.0327C92.2338 43.0929 92.0678 43.1456 91.894 43.1908C91.7204 43.2435 91.5468 43.2698 91.373 43.2698ZM93.0979 38.2578H94.9328V42.4006H95.8729V43.1005H93.0979V42.4006H94.038V38.9577H93.0979V38.2578ZM94.3665 35.8534C94.578 35.8534 94.7479 35.9175 94.8762 36.0453C95.0045 36.1732 95.0688 36.3425 95.0688 36.5533C95.0688 36.7641 95.0045 36.9334 94.8762 37.0613C94.7479 37.1891 94.578 37.2532 94.3665 37.2532C94.155 37.2532 93.9851 37.1891 93.8568 37.0613C93.7359 36.9334 93.6756 36.7641 93.6756 36.5533C93.6756 36.3425 93.7359 36.1732 93.8568 36.0453C93.9851 35.9175 94.155 35.8534 94.3665 35.8534ZM99.0637 38.0885C99.5697 38.0885 100.008 38.1938 100.378 38.4046C100.755 38.6078 101.05 38.9049 101.261 39.2963C101.473 39.6801 101.578 40.143 101.578 40.6848C101.578 41.4899 101.348 42.1221 100.887 42.5812C100.427 43.0403 99.8189 43.2698 99.0637 43.2698C98.5804 43.2698 98.15 43.1682 97.7725 42.965C97.4024 42.7542 97.1118 42.457 96.9003 42.0732C96.6965 41.6818 96.5945 41.219 96.5945 40.6848C96.5945 40.143 96.6965 39.6801 96.9003 39.2963C97.1118 38.9049 97.4024 38.6078 97.7725 38.4046C98.15 38.1938 98.5804 38.0885 99.0637 38.0885ZM99.075 38.8109C98.554 38.8109 98.1613 38.9766 97.8971 39.3076C97.6329 39.6313 97.5007 40.0902 97.5007 40.6848C97.5007 41.2794 97.6329 41.7383 97.8971 42.0619C98.1613 42.3856 98.554 42.5473 99.075 42.5473C99.6111 42.5473 100.011 42.3856 100.276 42.0619C100.54 41.7383 100.672 41.2794 100.672 40.6848C100.672 40.0902 100.54 39.6313 100.276 39.3076C100.011 38.9766 99.6111 38.8109 99.075 38.8109ZM102.291 43.1005V42.4006H103.243V39.1609L102.155 38.7884L102.393 38.0885L103.9 38.6078C104.164 38.4347 104.443 38.3067 104.738 38.224C105.04 38.1337 105.334 38.0885 105.621 38.0885C105.984 38.0885 106.316 38.1599 106.618 38.303C106.928 38.4384 107.173 38.6492 107.354 38.9351C107.543 39.2136 107.637 39.5673 107.637 39.9962V42.4006H108.589V43.1005H106.244V42.4006H106.754V40.1768C106.754 39.6951 106.629 39.3491 106.38 39.1383C106.138 38.9201 105.836 38.8109 105.474 38.8109C105.263 38.8109 105.04 38.8448 104.806 38.9125C104.579 38.9727 104.353 39.0669 104.126 39.1947V42.4006H104.636V43.1005H102.291Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_70_760",
    x: 0.82373,
    y: 5.74707,
    width: 5.43335,
    height: 34.7061,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_70_760"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_70_760",
    x: 9.06128,
    y: 5.74707,
    width: 17.7106,
    height: 8.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_70_760"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_70_760",
    x: 6.25696,
    y: 18.7295,
    width: 17.5155,
    height: 8.74121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_70_760"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_70_760",
    x: 31.7142,
    y: 12.5195,
    width: 10.0909,
    height: 8.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_70_760"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_70_760",
    x: 13.7977,
    y: 12.5195,
    width: 16.6809,
    height: 8.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_70_760"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_70_760",
    x: 13.7977,
    y: 38.585,
    width: 16.6809,
    height: 8.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_70_760"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_70_760",
    x: 31.7142,
    y: 38.3799,
    width: 10.0909,
    height: 8.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_70_760"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_70_760",
    x: 9.06128,
    y: 31.8125,
    width: 14.6216,
    height: 8.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_70_760"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_70_760",
    x: 25.1241,
    y: 12.5195,
    width: 12.4333,
    height: 34.7061,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_70_760"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_70_760",
    x1: 3.54043,
    y1: 5.74707,
    x2: 3.54043,
    y2: 36.4526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF845E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7347"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_70_760",
    x1: 17.9166,
    y1: 5.74707,
    x2: 17.9166,
    y2: 10.4676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF845E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7347"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_70_760",
    x1: 15.0147,
    y1: 18.7295,
    x2: 15.0147,
    y2: 23.4702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF845E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7347"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_70_760",
    x1: 36.7597,
    y1: 12.5195,
    x2: 36.7597,
    y2: 17.2401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF845E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7347"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_70_760",
    x1: 22.1382,
    y1: 12.5195,
    x2: 22.1382,
    y2: 17.2401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF845E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7347"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_70_760",
    x1: 22.1382,
    y1: 38.585,
    x2: 22.1382,
    y2: 43.3055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF845E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7347"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_70_760",
    x1: 36.7597,
    y1: 38.3799,
    x2: 36.7597,
    y2: 43.1004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF845E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7347"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_70_760",
    x1: 16.372,
    y1: 31.8125,
    x2: 16.372,
    y2: 36.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF845E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7347"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_70_760",
    x1: 27.8408,
    y1: 12.5195,
    x2: 27.8408,
    y2: 43.2251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF845E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7347"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEeti);
export default __webpack_public_path__ + "static/media/logo-eeti.564f637d467ea1cf7078c1a0f7a4b5aa.svg";
export { ForwardRef as ReactComponent };